// =============================================================================
// TYPES
// =============================================================================

export interface DiagonalElement {
  type: 'Diagonal';
  params: {
    /** Parent shape ID (Rectangle, Square, Parallelogram, Rhombus, Trapezoid) */
    of: string;
    /** Which diagonal to draw: pair of vertex names, e.g. ['A', 'C']. Default: both diagonals */
    vertices?: [string, string];
  };
}
